// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const UserAccountInfo = ({ onClose, token }) => {
//     const [userData, setUserData] = useState(null);
//     const [editAvatar, setEditAvatar] = useState(false);
//     const [editWish, setEditWish] = useState(false);
//     const [newAvatar, setNewAvatar] = useState('');
//     const [newWish, setNewWish] = useState('');

//     useEffect(() => {
//         const fetchAccountInfo = async () => {
//             try {
//                 const response = await axios.get('/accountInfo', {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//                 setUserData(response.data);
//                 setNewAvatar(response.data.avatar);
//                 setNewWish(response.data.wishes[0] || '');
//             } catch (error) {
//                 alert('Error fetching account info');
//             }
//         };

//         fetchAccountInfo();
//     }, [token]);

//     const handleAvatarUpdate = async () => {
//         try {
//             await axios.post(
//                 '/updateAvatar',
//                 { avatar: newAvatar },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setUserData({ ...userData, avatar: newAvatar });
//             setEditAvatar(false);
//             alert('Avatar updated successfully!');
//         } catch (error) {
//             alert('Error updating avatar');
//         }
//     };

//     const handleWishUpdate = async () => {
//         try {
//             await axios.post(
//                 '/addWish',
//                 { wish: newWish },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setUserData({
//                 ...userData,
//                 wishes: [newWish],
//             });
//             setEditWish(false);
//             alert('Wish updated successfully!');
//         } catch (error) {
//             alert('Error updating wish');
//         }
//     };

//     if (!userData) return <p>Loading...</p>;

//     // Set default values for supportedUsers
//     const supportedUsers = userData.supportedUsers || [];
//     const totalGaugeRaised = supportedUsers.reduce((sum, user) => sum + user.gaugeRaised, 0);
//     const numOfSupportedUsers = supportedUsers.length;

//     return (
//         <div className="user-account-info">
//             <button onClick={onClose}>닫기</button>
//             <h2>{userData.username}님의 신년 해</h2>

//             {/* Avatar */}
//             <div>
//                 <img src={`/assets/${userData.avatar}`} alt="Avatar" />
//                 {editAvatar ? (
//                     <div>
//                         <select value={newAvatar} onChange={(e) => setNewAvatar(e.target.value)}>
//                             {['Avarta1.png', 'Avarta2.png', 'Avarta3.png', 'Avarta4.png'].map((avatar) => (
//                                 <option key={avatar} value={avatar}>
//                                     {avatar}
//                                 </option>
//                             ))}
//                         </select>
//                         <button onClick={handleAvatarUpdate}>수정</button>
//                     </div>
//                 ) : (
//                     <button onClick={() => setEditAvatar(true)}>아바타 수정하기</button>
//                 )}
//             </div>

//             {/* Wish */}
//             <div>
//                 <p>소원: {userData.wishes[0] || 'No wish set'}</p>
//                 {editWish ? (
//                     <div>
//                         <input value={newWish} onChange={(e) => setNewWish(e.target.value)} />
//                         <button onClick={handleWishUpdate}>수정</button>
//                     </div>
//                 ) : (
//                     <button onClick={() => setEditWish(true)}>소원 수정하기</button>
//                 )}
//             </div>

//             {/* Gauge */}
//             <p>{userData.username}님의 신년 해의 높이는 {userData.gauge} 해돋음 입니다</p>
//             <p>{userData.supporters?.length || 0}명이 {userData.username}님의 신년 해가 뜨기를 기다립니다</p>

//             {/* Supported Users Info */}
//             <p>
//                 {userData.username}님은 다른 사람의 해를 {totalGaugeRaised} 해돋음 높였습니다
//             </p>
//             <p>
//                 {userData.username}님은 {numOfSupportedUsers}명의 2025년을 응원합니다
//             </p>
//         </div>
//     );
// };

// export default UserAccountInfo;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const UserAccountInfo = ({ onClose, token }) => {
//     const [userData, setUserData] = useState(null);
//     const [editAvatar, setEditAvatar] = useState(false);
//     const [editWish, setEditWish] = useState(false);
//     const [newAvatar, setNewAvatar] = useState('');
//     const [newWish, setNewWish] = useState('');

//     useEffect(() => {
//         const fetchAccountInfo = async () => {
//             try {
//                 const response = await axios.get('/accountInfo', {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//                 const data = response.data.data;
//                 setUserData(data);
//                 setNewAvatar(data.avatar || 'Avarta1.png');
//                 setNewWish(data.wishes[0] || '');
//             } catch (error) {
//                 alert('Error fetching account info');
//             }
//         };

//         fetchAccountInfo();
//     }, [token]);

//     const handleAvatarUpdate = async () => {
//         try {
//             await axios.post(
//                 '/updateAvatar',
//                 { avatar: newAvatar },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setUserData((prev) => ({ ...prev, avatar: newAvatar }));
//             setEditAvatar(false);
//             alert('Avatar updated successfully!');
//         } catch (error) {
//             alert('Error updating avatar');
//         }
//     };

//     const handleWishUpdate = async () => {
//         try {
//             await axios.post(
//                 '/addWish',
//                 { wish: newWish },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setUserData((prev) => ({ ...prev, wishes: [newWish] }));
//             setEditWish(false);
//             alert('Wish updated successfully!');
//         } catch (error) {
//             alert('Error updating wish');
//         }
//     };

//     if (!userData) return <p>Loading...</p>;

//     // Calculate total gaugeRaised and number of supported users
//     const supportedUsers = userData.supportedUsers || [];
//     const totalGaugeRaised = supportedUsers.reduce((sum, user) => sum + user.gaugeRaised, 0);
//     const numOfSupportedUsers = supportedUsers.length;

//     return (
//         <div className="user-account-info">
//             <button onClick={onClose}>닫기</button>
//             <h2>{userData.username}님의 신년 해</h2>

//             {/* Avatar */}
//             <div>
//                 <img src={`/assets/${userData.avatar}`} alt="Avatar" />
//                 {editAvatar ? (
//                     <div>
//                         <select value={newAvatar} onChange={(e) => setNewAvatar(e.target.value)}>
//                             {['Avarta1.png', 'Avarta2.png', 'Avarta3.png', 'Avarta4.png'].map((avatar) => (
//                                 <option key={avatar} value={avatar}>
//                                     {avatar}
//                                 </option>
//                             ))}
//                         </select>
//                         <button onClick={handleAvatarUpdate}>수정</button>
//                     </div>
//                 ) : (
//                     <button onClick={() => setEditAvatar(true)}>아바타 수정하기</button>
//                 )}
//             </div>

//             {/* Wish */}
//             <div>
//                 <p>소원: {userData.wishes[0] || 'No wish set'}</p>
//                 {editWish ? (
//                     <div>
//                         <input value={newWish} onChange={(e) => setNewWish(e.target.value)} />
//                         <button onClick={handleWishUpdate}>수정</button>
//                     </div>
//                 ) : (
//                     <button onClick={() => setEditWish(true)}>소원 수정하기</button>
//                 )}
//             </div>

//             {/* Gauge */}
//             <p>{userData.username}님의 신년 해의 높이는 {userData.gauge} 해돋음 입니다</p>
//             <p>{userData.supporters?.length || 0}명이 {userData.username}님의 신년 해가 뜨기를 기다립니다</p>

//             {/* Supported Users Info */}
//             <p>
//                 {userData.username}님은 다른 사람의 해를 {totalGaugeRaised} 해돋음 높였습니다
//             </p>
//             <p>
//                 {userData.username}님은 {numOfSupportedUsers}명의 2025년을 응원합니다
//             </p>
//         </div>
//     );
// };

// export default UserAccountInfo;

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserAccountInfo = ({ token, clientUuid , onClose}) => {
    const [userData, setUserData] = useState(null);
    const [editAvatar, setEditAvatar] = useState(false);
    const [editWish, setEditWish] = useState(false);
    const [newAvatar, setNewAvatar] = useState('');
    const [newWish, setNewWish] = useState('');
    const [avatarList, setAvatarList] = useState([])


    useEffect(() => {
        const fetchAccountInfo = async () => {
            try {
                const response = await axios.get(`/users/${clientUuid}/accountinfo`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = response.data.data;
                setUserData(data);
                setNewAvatar(data.avatar || 'Avarta1.png');
                setNewWish(data.wishes[0] || '');
            } catch (error) {
                alert('Error fetching account info');
            }
        };
        const fetchAvatarList = async () => {
            try {
                const response = await axios.get(`/shop/avatars`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const avatars = response.data.avatars
                setAvatarList(avatars)
            } catch (error) {
                alert('Error fetching AvatarList');
            }
        }


        fetchAccountInfo();
        fetchAvatarList();
    }, [token]);

    const handleAvatarUpdate = async () => {

        try {
            await axios.post(
                `/users/${clientUuid}/avatar`,
                { avatar: newAvatar },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setUserData((prev) => ({ ...prev, avatar: newAvatar }));
            setEditAvatar(false);
            alert('Avatar updated successfully!');
        } catch (error) {
            alert('Error updating avatar');
        }
    };

    const handleWishUpdate = async () => {
        try {
            await axios.post(
                `/users/${clientUuid}/wish`,
                { wish: newWish },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setUserData((prev) => ({ ...prev, wishes: [newWish] }));
            setEditWish(false);
            alert('Wish updated successfully!');
        } catch (error) {
            alert('Error updating wish');
        }
    };

    if (!userData) return <p>Loading...</p>;

    // Calculate total gaugeRaised and number of supported users
    const supportedUsers = userData.supportedUsers || [];
    const totalGaugeRaised = supportedUsers.reduce((sum, user) => sum + user.gaugeRaised, 0);
    const numOfSupportedUsers = supportedUsers.length;

    return (
        <div className="user-account-info">
        {/* <button onClick={onClose}>닫기</button> */}
        <h2>{userData.username}님의 신년 해</h2>
        <div className="user-account-row">
                {/* Avatar */}
                <div className="avatar-section">
                <h3>현재 아바타</h3>
                <img
                    src={`/assets/character/${userData.avatar}`}
                    alt="Avatar"
                    className="current-avatar"
                />
                </div>
            {/* Avatar */}
            {/* <div className='avatar-section'>
                <img src={`/assets/character/${userData.avatar}`} alt="Avatar" />
                {editAvatar ? (
                    <div>
                        <select value={newAvatar} onChange={(e) => setNewAvatar(e.target.value)}>
                            {avatarList.map((avatar) => (
                                <option key={avatar} value={avatar}>
                                    {avatar}
                                </option>
                            ))}
                        </select>
                        <button onClick={handleAvatarUpdate}>수정</button>
                    </div>
                ) : (
                    <button onClick={() => setEditAvatar(true)}>아바타 수정하기</button>
                )}
            </div> */}


            {/* Wish */}
            <div className='wish-section'>
                <p>소원: {userData.wishes[0] || 'No wish set'}</p>
                {editWish ? (
                    <div>
                        <input value={newWish} onChange={(e) => setNewWish(e.target.value)} />
                        <button onClick={handleWishUpdate}>수정</button>
                    </div>
                ) : (
                    <button onClick={() => setEditWish(true)}>소원 수정하기</button>
                )}
            </div>
            </div>
            <div className="avatar-section2">
            {editAvatar ? (
                    <div className="avatar-selection">
                    <h4>아바타 선택</h4>
                    <div className="avatar-list">
                        {avatarList.map((avatar) => (
                        <img
                            key={avatar}
                            src={`/assets/character/${avatar}`}
                            alt={avatar}
                            className={`avatar-preview ${newAvatar === avatar ? 'selected' : ''}`}
                            onClick={() => setNewAvatar(avatar)} // 클릭 시 선택
                        />
                        ))}
                    </div>
                    <button onClick={handleAvatarUpdate}>수정</button>
                    </div>
                ) : (
                    <button onClick={() => setEditAvatar(true)}>아바타 수정하기</button>
                )}
            </div>
            {/* Gauge */}
            <p>{userData.username}님의 신년 해의 높이는 {userData.gauge} 해돋음 입니다</p>
            <p>{userData.supporters?.length || 0}명이 {userData.username}님의 신년 해가 뜨기를 기다립니다</p>

            {/* Supported Users Info */}
            <p>
                {userData.username}님은 다른 사람의 해를 {totalGaugeRaised} 해돋음 높였습니다
            </p>
            <p>
                {userData.username}님은 {numOfSupportedUsers}명의 2025년을 응원합니다
            </p>
        </div>
    );
};

export default UserAccountInfo;